import { call } from './apiHelpers';

export const electoralRegisterService = {
  findByDocument: (document) =>
    call('get', 'padron/buscar/', null, { cedula: document }),
  getById: (id) => call('get', `electoral-register/${id}/`),
  getImports: () => call('get', 'electoral-register/imports/'),
  getImport: (id) => call('get', `electoral-register/imports/${id}/`),
  importCsv: (file, source, version) => {
    const form = new FormData();
    form.append('file', file);
    form.append('source', source);
    form.append('version', version);
    return call('post', 'electoral-register/import/', form);
  },
  activateImport: (id) =>
    call('post', `electoral-register/imports/${id}/activate/`, {}),
  getStats: () => call('get', 'electoral-register/stats/'),
};
